export default {
  name: "descriptions",
  methods: {
    // Truncates description text and adds "..."
    truncate: function (chars, text) {
      if (text) {
        if (text.length <= chars) {
          return text;
        } else {
          let space = " ";
          let slice = text.substring(0, text.lastIndexOf(space, chars));
          slice = slice + "...";
          return slice;
        }
      }
    },
    // Removes extra spaces/periods
    audit: function(string) {
      // Strip JSON quotation marks
      if (string && string.slice(0, 1) === '"' && string.slice (-1) === '"') {
        string = string.substring(1, string.length - 1);
      }
      if (string && string.slice(-1) === "." ||
        string && string.slice(-1) === " ") {
        string = string.substring(0, string.length - 1);
        if (string.slice(-1) === "." || string.slice(-1) === " ") {
          string = string.substring(0, string.length - 1);
        }
      }
      if (string && string.slice(-4) === "\\r\\n") {
        string = string.substring(0, string.length - 4);
      }
      return string;
    },
  },
};
